import { useEffect, useCallback, useMemo } from 'react';

const useKeyboardShortcuts = ({
    user,
    history,
    dispatch,
    showModal,
    notifyError,
    guest_fields,
    setGuestTableOpen,
    createGuest,
    MODAL_TYPE,
    ACTIVITER_USER_MANUAL
}) => {
    const isAdmin = user?.role === 'admin';
    const isAgent = user?.role === 'agent';
    const isCustomer = user?.role === 'customer';

    const isAdminOrAgent = isAdmin || isAgent;

    const keyActions = useMemo(
        () => ({
            F1: () => {
                if (user) {
                    history.push('/guests/me');
                } else {
                    showModal(MODAL_TYPE.SIGNIN);
                }
            },

            F2: e => {
                e.preventDefault();
                history.push('/');
            },

            F3: e => {
                e.preventDefault();
                if (!isAdminOrAgent) {
                    return;
                }
                history.push('/client/bookings');
            },

            F4: e => {
                e.preventDefault();
                if (!isAdminOrAgent) {
                    return;
                }
                setGuestTableOpen(prev => !prev);
            },

            F5: e => {
                e.preventDefault();
                if (!isAdminOrAgent) {
                    return;
                }
                history.push('/emaillog');
            },

            F7: e => {
                e.preventDefault();
                if (isAgent) {
                    window.open(ACTIVITER_USER_MANUAL, '_blank');
                }
                if (isAdmin) {
                    history.push('/admin/client/list?type=client');
                }
            },

            F8: e => {
                e.preventDefault();

                if (isAgent) {
                    showModal(MODAL_TYPE.CREATE_OR_UPDATE_GUEST, {
                        isAgent,
                        guest_fields,
                        handleSubmit: data => {
                            dispatch(
                                createGuest({
                                    firstname: data.firstname,
                                    lastname: data.lastname,
                                    phone: data.phone,
                                    email: data.email,
                                    additional_emails: data.additional_emails,
                                    guest_field_info: data.guest_field_info,
                                    arrival_date: data.arrival_date,
                                    departure_date: data.departure_date,
                                    internal_notes: data.internal_notes,
                                    notification: data.notification,
                                    source_id: data.source_id,
                                    onSuccess: () => showModal(MODAL_TYPE.NONE),
                                    onError: err => notifyError(err)
                                })
                            );
                        }
                    });
                }

                if (isAdmin) {
                    history.push('/admin/client/list?type=vendor');
                }
            },

            F9: e => {
                e.preventDefault();
                if (isAdmin) {
                    history.push('/admin/activities/list');
                }
            },

            F10: e => {
                e.preventDefault();
                if (isAdmin) {
                    history.push('/admin/bookingpayouts');
                }
            }
        }),
        [
            user,
            history,
            showModal,
            dispatch,
            notifyError,
            guest_fields,
            isAdmin,
            isAgent,
            isCustomer,
            setGuestTableOpen,
            MODAL_TYPE,
            ACTIVITER_USER_MANUAL,
            createGuest
        ]
    );

    const handleKeyDown = useCallback(
        e => {
            keyActions[e.key]?.(e);
        },
        [keyActions]
    );

    useEffect(() => {
        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [handleKeyDown]);
};

export default useKeyboardShortcuts;
